import React from "react";
import { Box, Container, Typography } from "@mui/material";
import component from "../../../assets/images/lp/component.jpg";
 
const items = [
  {
    no: "01",
    title: "ダッシュボード＆タスク管理",
    lines: ["担当者別・進捗状況別にタスクを一覧表示。", "日／週／月単位での進捗管理に対応。"],
  },
  {
    no: "02",
    title: "進捗がひと目で分かる集計チャート",
    lines: [
      "タスクや案件のステータス（完了・保留・却下・対応中）",
      "を円グラフ、ドーナツチャートでリアルタイムに可視化。",
    ],
  },
  {
    no: "03",
    title: "チケット＆問い合わせ管理",
    lines: ["未処理・処理中・完了などのステータスバッジによる", "視覚的な一覧表示。"],
  },
  {
    no: "04",
    title: "クイックリンク＆申請ショートカット",
    lines: [
      "休暇申請・会議室予約・名刺依頼・ITサポートなど、",
      "社内申請へワンクリックでアクセス。",
    ],
  },
  {
    no: "05",
    title: "自己評価＆案件進捗リスト",
    lines: ["顧客別・プロジェクト別のステータス確認と詳細アクションボタン。"],
  },
];
 
const ComponentsList = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          COMPONENTS
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, fontSize: { xs: "24px", md: "50px" }, mb: 1.5 }}
        >
          実装コンポーネント一覧（機能仕様の一例）
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(0,0,0,0.65)",
            mb: { xs: 4, md: 5 },
          }}
        >
          業務ポータルに必要なWebパーツを、モジュール単位で設計・実装します
        </Typography>
 
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: { xs: 4, md: 6 },
          }}
        >
          <Box>
            <Box
              sx={{
                borderRadius: "10px",
                // border: "1px solid rgba(0,0,0,0.1)",
                overflow: "hidden",
                backgroundColor: "#f7f7f8",
              }}
            >
              <Box
                component="img"
                src={component}
                alt="社内ポータル画面イメージ"
                sx={{
                  display: "block",
                  width: "100%",
                  height: { xs: 260, md: "100%" },
                  objectFit: "cover",
                  objectPosition: "top",
                }}
              />              
            </Box>
 
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                color: "rgba(0,0,0,0.75)",
                mt: 2,
              }}
            >
              実際の画像があれば（※画像は構築イメージです）と注釈を入れて配置
            </Typography>
          </Box>
 
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: 3, md: 3.5 },
              ml: { md: "50px" },
            }}
          >
            {items.map((item) => {
              return (
                <Box
                  key={item.no}
                  sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "50%",
                      backgroundColor: "#FF6000",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "18px",
                        letterSpacing: "initial",
                      }}
                    >
                      {item.no}
                    </Typography>
                  </Box>
                  <Box>
                    <Box sx={{ display: "inline-block", mb: 0.5 }}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "16px",
                          pb: "4px",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Box
                        sx={{
                          height: "2px",
                          width: "100%",
                          background:
                            "linear-gradient(to right, #FF6000, rgba(255,96,0,0))",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "rgba(0,0,0,0.6)",
                        lineHeight: 1.7,
                      }}
                    >
                      {item.lines.map((line, lineIndex) => (
                        <React.Fragment key={line}>
                          {line}
                          {lineIndex < item.lines.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
 
export default ComponentsList;